/* eslint-disable camelcase, new-cap */
import React from 'react';
import {UserSettings} from '../../utils/typescript-types/userSettings';
import useTranslation from '../../hooks/use-translation/use-translation';
import {P} from '../typography/typography';
import InfoIcon from '../info-icon/info-icon';

const ProductPrice = ({item, settings, customerProductData}: propTypes) => {
  const {t} = useTranslation();

  const price = (item, currency, considerCustomerOffer = true) => {
    let userCurrencySymbol = '';

    switch (currency) {
      case 'GBP':
        userCurrencySymbol = '£';
        break;
      case 'USD':
      case 'CAD':
      case 'AUD':
        userCurrencySymbol = '$';
        break;
      case 'EUR':
        userCurrencySymbol = '€';
        break;
    }

    let result = null;
    if (considerCustomerOffer && customerProductData?.offerPricing) {
      result = customerProductData.offerPricing[currency].price;
    }

    if (!result) {
      result = item.hasOwnProperty('prices')
        ? `${getPrintPrices(item, userCurrencySymbol)}`
        : item.pricing[currency].current_price;
    }

    return result;
  };

  const getPrintPrices = (item, userCurrencySymbol) => {
    const floatPrice = item.prices[settings.currency].toFixed(2);
    return `${userCurrencySymbol}${floatPrice}`;
  };

  const originalPrice = (item) => {
    const providerCurrency = item.hasOwnProperty('original_currency')
      ? item.original_currency
      : settings.currency;
    return price(item, providerCurrency);
  };

  const priceBeforeDiscount = (item) => item.pricing[settings.currency].original_price;

  const isConverted = () => settings.currency !== item.original_currency;

  const ConvertedIcon = ({item}) => {
    return (
      <>
        &nbsp;
        <InfoIcon
          text={
            `This artist is selling from ${item.artist_country},` +
            ` so we have converted the price from ${originalPrice(item)}.` +
            ` You will be charged in ${settings.currency}.`
          }
          size="15px"
        />
      </>
    );
  };

  return (
    <P style="p1">
      {item.is_in_stock && !item.in_sale && !customerProductData?.offerPricing && (
        <>
          <span className="header-art">{price(item, settings.currency)}</span>
          {isConverted() && ConvertedIcon({item})}
        </>
      )}

      {item.is_in_stock && item.in_sale && (
        <>
          <span className="header-art accent">
            {t('Now')} {price(item, settings.currency)}
          </span>
          &nbsp;&nbsp;
          {<del>{priceBeforeDiscount(item)}</del>}
          {isConverted() && ConvertedIcon({item})}
        </>
      )}

      {item.is_in_stock && !item.in_sale && customerProductData?.offerPricing && (
        <>
          <span className="header-art accent">
            {price(item, settings.currency)} {t('Offer Price')}
          </span>
          &nbsp;&nbsp;
          {<del>{price(item, settings.currency, false)}</del>}
          {isConverted() && ConvertedIcon({item})}
        </>
      )}

      {!item.is_in_stock && (
        <span className="header-art">
          <del>{price(item, settings.currency)}</del>
          &nbsp;
          {t('Sold')}
        </span>
      )}
    </P>
  );
};

interface propTypes {
  item: any;
  settings: UserSettings;
  customerProductData?: any;
}

export default ProductPrice;
